/**
* This file was @generated using pocketbase-typegen
*/

import type PocketBase from 'pocketbase'
import type { RecordService } from 'pocketbase'

export const Collections = {
	Authorigins: "_authOrigins",
	Externalauths: "_externalAuths",
	Mfas: "_mfas",
	Otps: "_otps",
	Superusers: "_superusers",
	AdItems: "ad_items",
	AdJournal: "ad_journal",
	AdRecipes: "ad_recipes",
	AdUnits: "ad_units",
	AgentDecisionOutbox: "agent_decision_outbox",
	AgentReviewEvents: "agent_review_events",
	AgentReviewTargets: "agent_review_targets",
	AgentReviews: "agent_reviews",
	AgentRuns: "agent_runs",
	AgentSecretaries: "agent_secretaries",
	AgentStatuses: "agent_statuses",
	AgentWorkItems: "agent_work_items",
	Assets: "assets",
	BodyMeasurements: "body_measurements",
	Cards: "cards",
	DailyStats: "daily_stats",
	Exercises: "exercises",
	FlowAssetTickets: "flow_asset_tickets",
	FlowAssets: "flow_assets",
	FlowCards: "flow_cards",
	FlowCategories: "flow_categories",
	FlowComments: "flow_comments",
	FlowVersions: "flow_versions",
	InboxItems: "inbox_items",
	InboxSettings: "inbox_settings",
	LibraryBlobs: "library_blobs",
	LibraryTokens: "library_tokens",
	McpTokens: "mcp_tokens",
	MuscleParts: "muscle_parts",
	OauthAuthorizations: "oauth_authorizations",
	OauthClients: "oauth_clients",
	OauthTokens: "oauth_tokens",
	OfficeAssets: "office_assets",
	OfficeObjects: "office_objects",
	OfficeRooms: "office_rooms",
	OrgMembers: "org_members",
	OrganicChannels: "organic_channels",
	OrganicItems: "organic_items",
	OrganicRecipes: "organic_recipes",
	PomodoroSessions: "pomodoro_sessions",
	Projects: "projects",
	ProviderKeys: "provider_keys",
	SkillPacks: "skill_packs",
	SkillVersions: "skill_versions",
	TamaDays: "tama_days",
	TaskNumberCounters: "task_number_counters",
	Tasks: "tasks",
	Users: "users",
	Workers: "workers",
	WorkoutDays: "workout_days",
	WorkoutSessionExercises: "workout_session_exercises",
	WorkoutSets: "workout_sets",
	WorkoutTemplates: "workout_templates",
	XpEvents: "xp_events",
} as const
export type Collections = typeof Collections[keyof typeof Collections]

// Alias types for improved usability
export type IsoDateString = string
export type IsoAutoDateString = string & { readonly autodate: unique symbol }
export type RecordIdString = string
export type FileNameString = string & { readonly filename: unique symbol }
export type HTMLString = string

type ExpandType<T> = unknown extends T
	? T extends unknown
		? { expand?: unknown }
		: { expand: T }
	: { expand: T }

// System fields
export type BaseSystemFields<T = unknown> = {
	id: RecordIdString
	collectionId: string
	collectionName: Collections
} & ExpandType<T>

export type AuthSystemFields<T = unknown> = {
	email: string
	emailVisibility: boolean
	username: string
	verified: boolean
} & BaseSystemFields<T>

// Record types for each collection

export type AuthoriginsRecord = {
	collectionRef: string
	created: IsoAutoDateString
	fingerprint: string
	id: string
	recordRef: string
	updated: IsoAutoDateString
}

export type ExternalauthsRecord = {
	collectionRef: string
	created: IsoAutoDateString
	id: string
	provider: string
	providerId: string
	recordRef: string
	updated: IsoAutoDateString
}

export type MfasRecord = {
	collectionRef: string
	created: IsoAutoDateString
	id: string
	method: string
	recordRef: string
	updated: IsoAutoDateString
}

export type OtpsRecord = {
	collectionRef: string
	created: IsoAutoDateString
	id: string
	password: string
	recordRef: string
	sentTo?: string
	updated: IsoAutoDateString
}

export type SuperusersRecord = {
	created: IsoAutoDateString
	email: string
	emailVisibility?: boolean
	id: string
	password: string
	tokenKey: string
	updated: IsoAutoDateString
	verified?: boolean
}

export const AdItemsStateOptions = {
	"draft": "draft",
	"live": "live",
	"queued": "queued",
	"removed": "removed",
} as const
export type AdItemsStateOptions = typeof AdItemsStateOptions[keyof typeof AdItemsStateOptions]

export const AdItemsMediaTypeOptions = {
	"video": "video",
	"image": "image",
} as const
export type AdItemsMediaTypeOptions = typeof AdItemsMediaTypeOptions[keyof typeof AdItemsMediaTypeOptions]

export const AdItemsHealthOptions = {
	"ok": "ok",
	"tired": "tired",
	"risk": "risk",
} as const
export type AdItemsHealthOptions = typeof AdItemsHealthOptions[keyof typeof AdItemsHealthOptions]

export const AdItemsFlowsStatusOptions = {
	"queued": "queued",
	"working": "working",
	"question": "question",
	"review": "review",
	"changes": "changes",
	"approved": "approved",
} as const
export type AdItemsFlowsStatusOptions = typeof AdItemsFlowsStatusOptions[keyof typeof AdItemsFlowsStatusOptions]
export type AdItemsRecord<Tdaily = unknown, Tgate = unknown, Tmetrics = unknown> = {
	budget_per_day?: number
	caption?: string
	code: string
	condition?: string
	created: IsoAutoDateString
	custom_html?: string
	daily?: null | Tdaily
	description?: string
	duration?: string
	flows_at?: IsoDateString
	flows_card?: string
	flows_owner?: string
	flows_status?: AdItemsFlowsStatusOptions
	flows_version?: number
	gate?: null | Tgate
	group?: string
	headline?: string
	health?: AdItemsHealthOptions
	hook?: string
	id: string
	media_type?: AdItemsMediaTypeOptions
	metrics?: null | Tmetrics
	notes?: string
	position?: number
	poster?: FileNameString
	ratio?: string
	removed_at?: IsoDateString
	removed_reason?: string
	started_at?: IsoDateString
	state: AdItemsStateOptions
	unit: RecordIdString
	updated: IsoAutoDateString
	updated_by_label?: string
	video?: FileNameString
	video_url?: string
	when_note?: string
	why?: string
}

export type AdJournalRecord<Trefs = unknown, Ttags = unknown> = {
	author_label?: string
	body?: string
	created: IsoAutoDateString
	id: string
	logged_at: IsoDateString
	refs?: null | Trefs
	slug: string
	source?: string
	tags?: null | Ttags
	title: string
	unit?: RecordIdString
	updated: IsoAutoDateString
}

export type AdRecipesRecord<Tfactors = unknown> = {
	created: IsoAutoDateString
	factors?: null | Tfactors
	id: string
	summary?: string
	unit: RecordIdString
	updated_by_label?: string
	version: number
}

export type AdUnitsRecord<Tkpi = unknown> = {
	archived_at?: IsoDateString
	color?: string
	created: IsoAutoDateString
	custom_html?: string
	daily_budget?: number
	id: string
	key: string
	kpi?: null | Tkpi
	name: string
	rules_md?: string
	slots?: number
	sort?: number
	updated: IsoAutoDateString
	updated_by_label?: string
}

export const AgentDecisionOutboxDecisionOptions = {
	"approved": "approved",
	"changes_requested": "changes_requested",
} as const
export type AgentDecisionOutboxDecisionOptions = typeof AgentDecisionOutboxDecisionOptions[keyof typeof AgentDecisionOutboxDecisionOptions]

export const AgentDecisionOutboxStatusOptions = {
	"pending": "pending",
	"claimed": "claimed",
	"completed": "completed",
	"needs_routing": "needs_routing",
	"failed": "failed",
} as const
export type AgentDecisionOutboxStatusOptions = typeof AgentDecisionOutboxStatusOptions[keyof typeof AgentDecisionOutboxStatusOptions]
export type AgentDecisionOutboxRecord = {
	attempts?: number
	card?: RecordIdString
	claim_expires_at?: IsoDateString
	claimed_by_thread_id?: string
	claimed_by_version?: number
	completed_at?: IsoDateString
	created: IsoAutoDateString
	decision: AgentDecisionOutboxDecisionOptions
	id: string
	images?: FileNameString[]
	last_error?: string
	message?: string
	project: RecordIdString
	review: RecordIdString
	routed_host_id?: string
	routed_thread_id?: string
	run?: RecordIdString
	status: AgentDecisionOutboxStatusOptions
	updated: IsoAutoDateString
	user?: RecordIdString
}

export const AgentReviewEventsEventTypeOptions = {
	"submitted": "submitted",
	"resubmitted": "resubmitted",
	"opened": "opened",
	"server_started": "server_started",
	"server_failed": "server_failed",
	"changes_requested": "changes_requested",
	"approved": "approved",
} as const
export type AgentReviewEventsEventTypeOptions = typeof AgentReviewEventsEventTypeOptions[keyof typeof AgentReviewEventsEventTypeOptions]

export const AgentReviewEventsActorKindOptions = {
	"secretary": "secretary",
	"sub_agent": "sub_agent",
	"workflow": "workflow",
	"human": "human",
	"system": "system",
} as const
export type AgentReviewEventsActorKindOptions = typeof AgentReviewEventsActorKindOptions[keyof typeof AgentReviewEventsActorKindOptions]
export type AgentReviewEventsRecord = {
	actor_kind: AgentReviewEventsActorKindOptions
	actor_label: string
	created: IsoAutoDateString
	event_type: AgentReviewEventsEventTypeOptions
	id: string
	message?: string
	review: RecordIdString
	revision: number
	user?: RecordIdString
}

export const AgentReviewTargetsKindOptions = {
	"browser": "browser",
	"file": "file",
	"command_output": "command_output",
	"report": "report",
} as const
export type AgentReviewTargetsKindOptions = typeof AgentReviewTargetsKindOptions[keyof typeof AgentReviewTargetsKindOptions]
export type AgentReviewTargetsRecord = {
	created: IsoAutoDateString
	environment?: string
	file_path?: string
	healthcheck_url?: string
	id: string
	kind: AgentReviewTargetsKindOptions
	label: string
	order?: number
	review: RecordIdString
	runtime_profile_key?: string
	updated: IsoAutoDateString
	url?: string
	user?: RecordIdString
	workspace_path?: string
}

export const AgentReviewsReviewTypeOptions = {
	"browser": "browser",
	"code": "code",
	"copy": "copy",
	"data": "data",
	"deployment": "deployment",
	"manual": "manual",
} as const
export type AgentReviewsReviewTypeOptions = typeof AgentReviewsReviewTypeOptions[keyof typeof AgentReviewsReviewTypeOptions]

export const AgentReviewsStatusOptions = {
	"draft": "draft",
	"ready": "ready",
	"changes_requested": "changes_requested",
	"approved": "approved",
	"superseded": "superseded",
} as const
export type AgentReviewsStatusOptions = typeof AgentReviewsStatusOptions[keyof typeof AgentReviewsStatusOptions]
export type AgentReviewsRecord = {
	card?: RecordIdString
	created: IsoAutoDateString
	id: string
	project: RecordIdString
	requested_action?: string
	resolved_at?: IsoDateString
	review_type: AgentReviewsReviewTypeOptions
	revision: number
	run?: RecordIdString
	status: AgentReviewsStatusOptions
	submission_key: string
	submitted_at?: IsoDateString
	summary: string
	supersedes_review_id?: string
	title: string
	updated: IsoAutoDateString
	user?: RecordIdString
	work_item?: RecordIdString
}

export const AgentRunsAgentKindOptions = {
	"secretary": "secretary",
	"sub_agent": "sub_agent",
	"workflow": "workflow",
	"human": "human",
} as const
export type AgentRunsAgentKindOptions = typeof AgentRunsAgentKindOptions[keyof typeof AgentRunsAgentKindOptions]

export const AgentRunsStatusOptions = {
	"queued": "queued",
	"running": "running",
	"waiting": "waiting",
	"completed": "completed",
	"failed": "failed",
	"cancelled": "cancelled",
} as const
export type AgentRunsStatusOptions = typeof AgentRunsStatusOptions[keyof typeof AgentRunsStatusOptions]
export type AgentRunsRecord = {
	agent_kind: AgentRunsAgentKindOptions
	agent_label: string
	card?: RecordIdString
	created: IsoAutoDateString
	external_run_id: string
	finished_at?: IsoDateString
	id: string
	origin_host_id?: string
	origin_thread_id?: string
	parent_external_run_id?: string
	phase?: string
	progress_percent?: number
	project?: RecordIdString
	started_at?: IsoDateString
	status: AgentRunsStatusOptions
	summary?: string
	updated: IsoAutoDateString
	user?: RecordIdString
	work_item?: RecordIdString
	workspace_path?: string
}

export const AgentSecretariesStatusOptions = {
	"active": "active",
	"revoked": "revoked",
} as const
export type AgentSecretariesStatusOptions = typeof AgentSecretariesStatusOptions[keyof typeof AgentSecretariesStatusOptions]
export type AgentSecretariesRecord = {
	activated_at?: IsoDateString
	automation_id?: string
	created: IsoAutoDateString
	holder_host_id?: string
	holder_label?: string
	holder_thread_id?: string
	id: string
	last_heartbeat_at?: IsoDateString
	lease_expires_at?: IsoDateString
	lease_version: number
	revoke_reason?: string
	revoked_at?: IsoDateString
	scope_key: string
	status: AgentSecretariesStatusOptions
	updated: IsoAutoDateString
	user?: RecordIdString
}

export type AgentStatusesRecord = {
	avatar_url?: string
	created: IsoAutoDateString
	id: string
	image?: FileNameString
	message: string
	posts?: number
	project: string
	session_key: string
	updated: IsoAutoDateString
	user?: RecordIdString
}

export const AgentWorkItemsStatusOptions = {
	"queued": "queued",
	"running": "running",
	"needs_you": "needs_you",
	"done": "done",
	"cancelled": "cancelled",
} as const
export type AgentWorkItemsStatusOptions = typeof AgentWorkItemsStatusOptions[keyof typeof AgentWorkItemsStatusOptions]

export const AgentWorkItemsSourceKindOptions = {
	"inbox": "inbox",
	"task": "task",
} as const
export type AgentWorkItemsSourceKindOptions = typeof AgentWorkItemsSourceKindOptions[keyof typeof AgentWorkItemsSourceKindOptions]

export const AgentWorkItemsPreviousInboxStatusOptions = {
	"new": "new",
	"read": "read",
	"archived": "archived",
} as const
export type AgentWorkItemsPreviousInboxStatusOptions = typeof AgentWorkItemsPreviousInboxStatusOptions[keyof typeof AgentWorkItemsPreviousInboxStatusOptions]
export type AgentWorkItemsRecord = {
	agent_label?: string
	card?: RecordIdString
	claimed_at?: IsoDateString
	completed_at?: IsoDateString
	created: IsoAutoDateString
	id: string
	images?: FileNameString[]
	instructions: string
	needs_you_reason?: string
	needs_you_replied_at?: IsoDateString
	needs_you_reply?: string
	previous_inbox_status?: AgentWorkItemsPreviousInboxStatusOptions
	project?: RecordIdString
	source_date?: IsoDateString
	source_description?: string
	source_id: string
	source_kind: AgentWorkItemsSourceKindOptions
	source_sender?: string
	source_title: string
	status: AgentWorkItemsStatusOptions
	title: string
	updated: IsoAutoDateString
	user?: RecordIdString
}

export const AssetsKindOptions = {
	"image": "image",
	"video": "video",
	"audio": "audio",
	"other": "other",
} as const
export type AssetsKindOptions = typeof AssetsKindOptions[keyof typeof AssetsKindOptions]

export const AssetsStatusOptions = {
	"active": "active",
	"retired": "retired",
} as const
export type AssetsStatusOptions = typeof AssetsStatusOptions[keyof typeof AssetsStatusOptions]
export type AssetsRecord<Ttags = unknown> = {
	blob: RecordIdString
	bu?: string
	character?: string
	created: IsoAutoDateString
	created_by_label?: string
	height?: number
	id: string
	kind: AssetsKindOptions
	model?: string
	prompt?: string
	sha256: string
	source?: string
	source_ref?: string
	status: AssetsStatusOptions
	tags?: null | Ttags
	title?: string
	updated: IsoAutoDateString
	width?: number
}

export type BodyMeasurementsRecord = {
	circumference_cm: number
	created: IsoAutoDateString
	date_key: string
	id: string
	note?: string
	part: RecordIdString
	updated: IsoAutoDateString
	user?: RecordIdString
}

export const CardsStatusOptions = {
	"backlog": "backlog",
	"to-do": "to-do",
	"blocking": "blocking",
	"in-progress": "in-progress",
	"in-review": "in-review",
	"done": "done",
	"archived": "archived",
} as const
export type CardsStatusOptions = typeof CardsStatusOptions[keyof typeof CardsStatusOptions]

export const CardsPriorityOptions = {
	"critical": "critical",
	"high": "high",
	"medium": "medium",
	"low": "low",
} as const
export type CardsPriorityOptions = typeof CardsPriorityOptions[keyof typeof CardsPriorityOptions]
export type CardsRecord<Ttags = unknown> = {
	created: IsoAutoDateString
	description?: string
	due_date?: IsoDateString
	id: string
	images?: FileNameString[]
	issue_key: string
	order?: number
	owner?: string
	priority?: CardsPriorityOptions
	project: RecordIdString
	status: CardsStatusOptions
	tags?: null | Ttags
	title: string
	type?: string
	updated: IsoAutoDateString
	user?: RecordIdString
}

export type DailyStatsRecord = {
	created: IsoAutoDateString
	date_key: string
	id: string
	pomodoros?: number
	tasks_done?: number
	tasks_total?: number
	updated: IsoAutoDateString
	user?: RecordIdString
	workout_completed?: boolean
	workout_done?: number
	workout_total?: number
}

export const ExercisesMuscleGroupOptions = {
	"push": "push",
	"pull": "pull",
	"legs": "legs",
	"core": "core",
	"cardio": "cardio",
	"other": "other",
} as const
export type ExercisesMuscleGroupOptions = typeof ExercisesMuscleGroupOptions[keyof typeof ExercisesMuscleGroupOptions]

export const ExercisesLoadTypeOptions = {
	"bodyweight": "bodyweight",
	"dumbbell": "dumbbell",
	"barbell": "barbell",
	"kettlebell": "kettlebell",
	"machine": "machine",
	"band": "band",
} as const
export type ExercisesLoadTypeOptions = typeof ExercisesLoadTypeOptions[keyof typeof ExercisesLoadTypeOptions]
export type ExercisesRecord<Tlast_summary = unknown> = {
	archived?: boolean
	code: string
	created: IsoAutoDateString
	id: string
	last_summary?: null | Tlast_summary
	load_type?: ExercisesLoadTypeOptions
	muscle_group?: ExercisesMuscleGroupOptions
	name: string
	updated: IsoAutoDateString
	user?: RecordIdString
}

export type FlowAssetTicketsRecord = {
	created: IsoAutoDateString
	expires_at: IsoDateString
	id: string
	token_hash: string
	updated: IsoAutoDateString
	user?: RecordIdString
}

export type FlowAssetsRecord = {
	created: IsoAutoDateString
	file: FileNameString
	id: string
	updated: IsoAutoDateString
	user?: RecordIdString
}

export const FlowCardsKindOptions = {
	"task": "task",
	"ad": "ad",
} as const
export type FlowCardsKindOptions = typeof FlowCardsKindOptions[keyof typeof FlowCardsKindOptions]

export const FlowCardsStatusOptions = {
	"queued": "queued",
	"review": "review",
	"decided": "decided",
	"picked": "picked",
	"done": "done",
} as const
export type FlowCardsStatusOptions = typeof FlowCardsStatusOptions[keyof typeof FlowCardsStatusOptions]

export const FlowCardsDecisionOptions = {
	"approve": "approve",
	"changes": "changes",
	"reject": "reject",
	"answer": "answer",
} as const
export type FlowCardsDecisionOptions = typeof FlowCardsDecisionOptions[keyof typeof FlowCardsDecisionOptions]

export const FlowCardsOriginOptions = {
	"agent": "agent",
	"owner": "owner",
} as const
export type FlowCardsOriginOptions = typeof FlowCardsOriginOptions[keyof typeof FlowCardsOriginOptions]

export const FlowCardsSourceKindOptions = {
	"task": "task",
	"inbox": "inbox",
	"ad": "ad",
	"organic": "organic",
} as const
export type FlowCardsSourceKindOptions = typeof FlowCardsSourceKindOptions[keyof typeof FlowCardsSourceKindOptions]
export type FlowCardsRecord = {
	agent_label?: string
	category: RecordIdString
	created: IsoAutoDateString
	decided_at?: IsoDateString
	decision?: FlowCardsDecisionOptions
	done_at?: IsoDateString
	done_note?: string
	id: string
	kind: FlowCardsKindOptions
	origin?: FlowCardsOriginOptions
	picked_at?: IsoDateString
	picked_by?: string
	previous_inbox_status?: string
	question?: string
	question_at?: IsoDateString
	session_key?: string
	source_id?: string
	source_kind?: FlowCardsSourceKindOptions
	source_title?: string
	status: FlowCardsStatusOptions
	submission_key: string
	summary?: string
	title: string
	updated: IsoAutoDateString
	user?: RecordIdString
	version: number
}

export type FlowCategoriesRecord = {
	archived_at?: IsoDateString
	created: IsoAutoDateString
	id: string
	key: string
	name: string
	updated: IsoAutoDateString
	user?: RecordIdString
}

export const FlowCommentsAuthorOptions = {
	"owner": "owner",
	"agent": "agent",
} as const
export type FlowCommentsAuthorOptions = typeof FlowCommentsAuthorOptions[keyof typeof FlowCommentsAuthorOptions]

export const FlowCommentsDecisionOptions = {
	"approve": "approve",
	"changes": "changes",
	"reject": "reject",
} as const
export type FlowCommentsDecisionOptions = typeof FlowCommentsDecisionOptions[keyof typeof FlowCommentsDecisionOptions]
export type FlowCommentsRecord<Tcitations = unknown> = {
	author: FlowCommentsAuthorOptions
	body?: string
	card: RecordIdString
	citations?: null | Tcitations
	created: IsoAutoDateString
	decision?: FlowCommentsDecisionOptions
	id: string
	label?: string
	updated: IsoAutoDateString
	user?: RecordIdString
	version: number
}

export type FlowVersionsRecord<Tad = unknown, Tblocks = unknown> = {
	ad?: null | Tad
	blocks?: null | Tblocks
	card: RecordIdString
	created: IsoAutoDateString
	id: string
	note?: string
	number: number
	submission_key?: string
	updated: IsoAutoDateString
	user?: RecordIdString
}

export const InboxItemsStatusOptions = {
	"new": "new",
	"read": "read",
	"archived": "archived",
} as const
export type InboxItemsStatusOptions = typeof InboxItemsStatusOptions[keyof typeof InboxItemsStatusOptions]
export type InboxItemsRecord = {
	attachments?: FileNameString[]
	created: IsoAutoDateString
	description?: string
	flow_card?: RecordIdString
	id: string
	read_at?: IsoDateString
	sender: string
	source?: string
	status: InboxItemsStatusOptions
	title: string
	updated: IsoAutoDateString
	user?: RecordIdString
	work_item?: RecordIdString
}

export type InboxSettingsRecord = {
	created: IsoAutoDateString
	id: string
	token: string
	updated: IsoAutoDateString
	user?: RecordIdString
}

export type LibraryBlobsRecord = {
	created: IsoAutoDateString
	created_by_label?: string
	file: FileNameString
	id: string
	mime?: string
	sha256: string
	size?: number
	updated: IsoAutoDateString
}

export type LibraryTokensRecord<Tinstalled = unknown> = {
	created: IsoAutoDateString
	id: string
	installed?: null | Tinstalled
	last_ip?: string
	last_sync_at?: IsoDateString
	name: string
	token_hash: string
	updated: IsoAutoDateString
	user: RecordIdString
}

export type McpTokensRecord = {
	created: IsoAutoDateString
	id: string
	last_used_at?: IsoDateString
	token_hash: string
	updated: IsoAutoDateString
	user?: RecordIdString
}

export type MusclePartsRecord = {
	archived?: boolean
	created: IsoAutoDateString
	id: string
	name: string
	note?: string
	updated: IsoAutoDateString
	user?: RecordIdString
}

export const OauthAuthorizationsStatusOptions = {
	"pending": "pending",
	"approved": "approved",
	"denied": "denied",
	"consumed": "consumed",
} as const
export type OauthAuthorizationsStatusOptions = typeof OauthAuthorizationsStatusOptions[keyof typeof OauthAuthorizationsStatusOptions]
export type OauthAuthorizationsRecord = {
	client: RecordIdString
	code_challenge: string
	code_hash?: string
	consumed_at?: IsoDateString
	created: IsoAutoDateString
	expires_at: IsoDateString
	id: string
	redirect_uri: string
	resource?: string
	scope?: string
	state?: string
	status: OauthAuthorizationsStatusOptions
	token?: string
	updated: IsoAutoDateString
	user?: RecordIdString
}

export const OauthClientsKindOptions = {
	"dcr": "dcr",
	"cimd": "cimd",
} as const
export type OauthClientsKindOptions = typeof OauthClientsKindOptions[keyof typeof OauthClientsKindOptions]
export type OauthClientsRecord<Tredirect_uris = unknown> = {
	client_id: string
	client_name?: string
	created: IsoAutoDateString
	id: string
	kind: OauthClientsKindOptions
	last_used_at?: IsoDateString
	metadata_fetched_at?: IsoDateString
	redirect_uris?: null | Tredirect_uris
	updated: IsoAutoDateString
}

export type OauthTokensRecord = {
	access_expires?: IsoDateString
	access_hash: string
	client?: RecordIdString
	client_name?: string
	created: IsoAutoDateString
	id: string
	last_used_at?: IsoDateString
	prev_refresh_hash?: string
	redirect_host?: string
	refresh_hash: string
	resource?: string
	revoked_at?: IsoDateString
	scope?: string
	updated: IsoAutoDateString
	user?: RecordIdString
}

export const OfficeAssetsKindOptions = {
	"tile": "tile",
	"furniture": "furniture",
	"character": "character",
} as const
export type OfficeAssetsKindOptions = typeof OfficeAssetsKindOptions[keyof typeof OfficeAssetsKindOptions]
export type OfficeAssetsRecord<Tframes = unknown, Ttags = unknown> = {
	created: IsoAutoDateString
	credit?: string
	frames?: null | Tframes
	id: string
	key: string
	kind: OfficeAssetsKindOptions
	name: string
	sheet?: FileNameString
	tags?: null | Ttags
	updated: IsoAutoDateString
	updated_by_label?: string
}

export type OfficeObjectsRecord<Tinteraction = unknown> = {
	asset_key: string
	client_key?: string
	created: IsoAutoDateString
	flip?: boolean
	id: string
	interaction?: null | Tinteraction
	note_body?: string
	note_title?: string
	room: RecordIdString
	updated: IsoAutoDateString
	updated_by_label?: string
	x?: number
	y?: number
	z?: number
}

export const OfficeRoomsScopeOptions = {
	"org": "org",
	"personal": "personal",
	"template": "template",
} as const
export type OfficeRoomsScopeOptions = typeof OfficeRoomsScopeOptions[keyof typeof OfficeRoomsScopeOptions]
export type OfficeRoomsRecord<Tlayers = unknown, Tspawn = unknown> = {
	created: IsoAutoDateString
	height: number
	id: string
	layers?: null | Tlayers
	name: string
	owner?: RecordIdString
	scope: OfficeRoomsScopeOptions
	spawn?: null | Tspawn
	updated: IsoAutoDateString
	updated_by_label?: string
	width: number
}

export type OrgMembersRecord = {
	can_write?: boolean
	created: IsoAutoDateString
	id: string
	updated: IsoAutoDateString
	user: RecordIdString
}

export const OrganicChannelsPlatformOptions = {
	"fb": "fb",
	"ig": "ig",
	"tt": "tt",
	"yt": "yt",
} as const
export type OrganicChannelsPlatformOptions = typeof OrganicChannelsPlatformOptions[keyof typeof OrganicChannelsPlatformOptions]
export type OrganicChannelsRecord = {
	archived_at?: IsoDateString
	bu: string
	created: IsoAutoDateString
	external_id?: string
	id: string
	key: string
	name: string
	page_url?: string
	platform: OrganicChannelsPlatformOptions
	sort?: number
	updated: IsoAutoDateString
	updated_by_label?: string
}

export const OrganicItemsFormatOptions = {
	"r916": "r916",
	"r169": "r169",
	"r45": "r45",
	"photo": "photo",
	"album": "album",
	"text": "text",
	"story": "story",
	"live": "live",
} as const
export type OrganicItemsFormatOptions = typeof OrganicItemsFormatOptions[keyof typeof OrganicItemsFormatOptions]

export const OrganicItemsStepOptions = {
	"idea": "idea",
	"flows": "flows",
	"ready": "ready",
	"scheduled": "scheduled",
	"posted": "posted",
	"measured": "measured",
} as const
export type OrganicItemsStepOptions = typeof OrganicItemsStepOptions[keyof typeof OrganicItemsStepOptions]

export const OrganicItemsFlowsStatusOptions = {
	"queued": "queued",
	"working": "working",
	"question": "question",
	"review": "review",
	"changes": "changes",
	"approved": "approved",
} as const
export type OrganicItemsFlowsStatusOptions = typeof OrganicItemsFlowsStatusOptions[keyof typeof OrganicItemsFlowsStatusOptions]
export type OrganicItemsRecord<Tsent_ads = unknown, Tversions = unknown> = {
	caption?: string
	code: string
	created: IsoAutoDateString
	flows_at?: IsoDateString
	flows_card?: string
	flows_owner?: string
	flows_status?: OrganicItemsFlowsStatusOptions
	flows_version?: number
	format: OrganicItemsFormatOptions
	id: string
	notes?: string
	pillar?: string
	poster?: FileNameString
	sent_ads?: null | Tsent_ads
	series?: string
	step: OrganicItemsStepOptions
	title: string
	updated: IsoAutoDateString
	updated_by_label?: string
	versions?: null | Tversions
	video?: FileNameString
}

export type OrganicRecipesRecord<Tfactors = unknown> = {
	bu: string
	created: IsoAutoDateString
	factors?: null | Tfactors
	id: string
	summary?: string
	updated_by_label?: string
	version: number
}

export type PomodoroSessionsRecord = {
	completed_at: IsoDateString
	created: IsoAutoDateString
	date_key: string
	duration_seconds?: number
	id: string
	updated: IsoAutoDateString
	user?: RecordIdString
}

export type ProjectsRecord = {
	archived_at?: IsoDateString
	created: IsoAutoDateString
	id: string
	name: string
	order?: number
	slug: string
	updated: IsoAutoDateString
	user?: RecordIdString
}

export const ProviderKeysProviderOptions = {
	"openrouter": "openrouter",
	"fal": "fal",
	"openai": "openai",
	"soniox": "soniox",
	"gemini": "gemini",
} as const
export type ProviderKeysProviderOptions = typeof ProviderKeysProviderOptions[keyof typeof ProviderKeysProviderOptions]

export const ProviderKeysStateOptions = {
	"connected": "connected",
	"action_required": "action_required",
	"error": "error",
	"missing": "missing",
} as const
export type ProviderKeysStateOptions = typeof ProviderKeysStateOptions[keyof typeof ProviderKeysStateOptions]
export type ProviderKeysRecord<Tmetrics = unknown> = {
	balance?: number
	checked_at?: IsoDateString
	created: IsoAutoDateString
	currency?: string
	dashboard_url?: string
	env_var?: string
	id: string
	is_low?: boolean
	key: string
	label?: string
	last4?: string
	message?: string
	metrics?: null | Tmetrics
	provider: ProviderKeysProviderOptions
	secret_enc?: string
	sort?: number
	state?: ProviderKeysStateOptions
	threshold?: number
	updated: IsoAutoDateString
	updated_by_label?: string
}

export type SkillPacksRecord = {
	created: IsoAutoDateString
	current_version?: number
	description?: string
	hermes_category?: string
	id: string
	name: string
	scope?: string
	title?: string
	updated: IsoAutoDateString
	updated_by_label?: string
}

export type SkillVersionsRecord<Tmanifest = unknown, Tscan = unknown> = {
	changelog?: string
	created: IsoAutoDateString
	created_by_label?: string
	id: string
	manifest?: null | Tmanifest
	pack: RecordIdString
	scan?: null | Tscan
	updated: IsoAutoDateString
	version: number
}

export type TamaDaysRecord = {
	created: IsoAutoDateString
	date_key: string
	id: string
	meals?: number
	note?: string
	updated: IsoAutoDateString
	user?: RecordIdString
}

export type TaskNumberCountersRecord = {
	id: string
	last_number?: number
	user?: RecordIdString
}

export const TasksPriorityOptions = {
	"high": "high",
	"medium": "medium",
} as const
export type TasksPriorityOptions = typeof TasksPriorityOptions[keyof typeof TasksPriorityOptions]
export type TasksRecord<Ttags = unknown> = {
	carried_from?: IsoDateString
	created: IsoAutoDateString
	date: IsoDateString
	description?: string
	done?: boolean
	done_at?: IsoDateString
	flow_card?: RecordIdString
	id: string
	images?: FileNameString[]
	order?: number
	pinned_at?: IsoDateString
	priority?: TasksPriorityOptions
	tags?: null | Ttags
	task_number: number
	title: string
	updated: IsoAutoDateString
	user?: RecordIdString
	work_item?: RecordIdString
}

export type UsersRecord = {
	avatar?: FileNameString
	created: IsoAutoDateString
	email: string
	emailVisibility?: boolean
	id: string
	name?: string
	password: string
	tokenKey: string
	updated: IsoAutoDateString
	verified?: boolean
}

export const WorkersStateOptions = {
	"idle": "idle",
	"working": "working",
	"error": "error",
} as const
export type WorkersStateOptions = typeof WorkersStateOptions[keyof typeof WorkersStateOptions]
export type WorkersRecord<Tcategories = unknown, Ttoday = unknown> = {
	categories?: null | Tcategories
	created: IsoAutoDateString
	current_card?: string
	current_owner?: string
	current_title?: string
	disk_gb?: number
	disk_used_pct?: number
	droplet_id?: string
	fx_usd_thb?: number
	id: string
	key: string
	last_error?: string
	last_result?: string
	last_seen?: IsoDateString
	memory_mb?: number
	name?: string
	price_usd_month?: number
	priced_at?: IsoDateString
	provider?: string
	region?: string
	role?: string
	size_slug?: string
	started_at?: IsoDateString
	state?: WorkersStateOptions
	today?: null | Ttoday
	updated: IsoAutoDateString
	updated_by_label?: string
	vcpus?: number
}

export type WorkoutDaysRecord<Titems = unknown> = {
	completed?: boolean
	created: IsoAutoDateString
	date: IsoDateString
	id: string
	items?: null | Titems
	updated: IsoAutoDateString
	user?: RecordIdString
}

export type WorkoutSessionExercisesRecord = {
	created: IsoAutoDateString
	date_key: string
	exercise: RecordIdString
	id: string
	order?: number
	updated: IsoAutoDateString
	user?: RecordIdString
}

export type WorkoutSetsRecord = {
	created: IsoAutoDateString
	date_key: string
	exercise: RecordIdString
	id: string
	note?: string
	reps: number
	updated: IsoAutoDateString
	user?: RecordIdString
	weight?: number
}

export type WorkoutTemplatesRecord<Titems = unknown> = {
	active?: boolean
	created: IsoAutoDateString
	id: string
	items?: null | Titems
	name: string
	updated: IsoAutoDateString
	user?: RecordIdString
}

export type XpEventsRecord = {
	created: IsoAutoDateString
	created_at: IsoDateString
	date_key: string
	id: string
	kind: string
	points?: number
	updated: IsoAutoDateString
	user?: RecordIdString
}

// Response types include system fields and match responses from the PocketBase API
export type AuthoriginsResponse<Texpand = unknown> = Required<AuthoriginsRecord> & BaseSystemFields<Texpand>
export type ExternalauthsResponse<Texpand = unknown> = Required<ExternalauthsRecord> & BaseSystemFields<Texpand>
export type MfasResponse<Texpand = unknown> = Required<MfasRecord> & BaseSystemFields<Texpand>
export type OtpsResponse<Texpand = unknown> = Required<OtpsRecord> & BaseSystemFields<Texpand>
export type SuperusersResponse<Texpand = unknown> = Required<SuperusersRecord> & AuthSystemFields<Texpand>
export type AdItemsResponse<Tdaily = unknown, Tgate = unknown, Tmetrics = unknown, Texpand = unknown> = Required<AdItemsRecord<Tdaily, Tgate, Tmetrics>> & BaseSystemFields<Texpand>
export type AdJournalResponse<Trefs = unknown, Ttags = unknown, Texpand = unknown> = Required<AdJournalRecord<Trefs, Ttags>> & BaseSystemFields<Texpand>
export type AdRecipesResponse<Tfactors = unknown, Texpand = unknown> = Required<AdRecipesRecord<Tfactors>> & BaseSystemFields<Texpand>
export type AdUnitsResponse<Tkpi = unknown, Texpand = unknown> = Required<AdUnitsRecord<Tkpi>> & BaseSystemFields<Texpand>
export type AgentDecisionOutboxResponse<Texpand = unknown> = Required<AgentDecisionOutboxRecord> & BaseSystemFields<Texpand>
export type AgentReviewEventsResponse<Texpand = unknown> = Required<AgentReviewEventsRecord> & BaseSystemFields<Texpand>
export type AgentReviewTargetsResponse<Texpand = unknown> = Required<AgentReviewTargetsRecord> & BaseSystemFields<Texpand>
export type AgentReviewsResponse<Texpand = unknown> = Required<AgentReviewsRecord> & BaseSystemFields<Texpand>
export type AgentRunsResponse<Texpand = unknown> = Required<AgentRunsRecord> & BaseSystemFields<Texpand>
export type AgentSecretariesResponse<Texpand = unknown> = Required<AgentSecretariesRecord> & BaseSystemFields<Texpand>
export type AgentStatusesResponse<Texpand = unknown> = Required<AgentStatusesRecord> & BaseSystemFields<Texpand>
export type AgentWorkItemsResponse<Texpand = unknown> = Required<AgentWorkItemsRecord> & BaseSystemFields<Texpand>
export type AssetsResponse<Ttags = unknown, Texpand = unknown> = Required<AssetsRecord<Ttags>> & BaseSystemFields<Texpand>
export type BodyMeasurementsResponse<Texpand = unknown> = Required<BodyMeasurementsRecord> & BaseSystemFields<Texpand>
export type CardsResponse<Ttags = unknown, Texpand = unknown> = Required<CardsRecord<Ttags>> & BaseSystemFields<Texpand>
export type DailyStatsResponse<Texpand = unknown> = Required<DailyStatsRecord> & BaseSystemFields<Texpand>
export type ExercisesResponse<Tlast_summary = unknown, Texpand = unknown> = Required<ExercisesRecord<Tlast_summary>> & BaseSystemFields<Texpand>
export type FlowAssetTicketsResponse<Texpand = unknown> = Required<FlowAssetTicketsRecord> & BaseSystemFields<Texpand>
export type FlowAssetsResponse<Texpand = unknown> = Required<FlowAssetsRecord> & BaseSystemFields<Texpand>
export type FlowCardsResponse<Texpand = unknown> = Required<FlowCardsRecord> & BaseSystemFields<Texpand>
export type FlowCategoriesResponse<Texpand = unknown> = Required<FlowCategoriesRecord> & BaseSystemFields<Texpand>
export type FlowCommentsResponse<Tcitations = unknown, Texpand = unknown> = Required<FlowCommentsRecord<Tcitations>> & BaseSystemFields<Texpand>
export type FlowVersionsResponse<Tad = unknown, Tblocks = unknown, Texpand = unknown> = Required<FlowVersionsRecord<Tad, Tblocks>> & BaseSystemFields<Texpand>
export type InboxItemsResponse<Texpand = unknown> = Required<InboxItemsRecord> & BaseSystemFields<Texpand>
export type InboxSettingsResponse<Texpand = unknown> = Required<InboxSettingsRecord> & BaseSystemFields<Texpand>
export type LibraryBlobsResponse<Texpand = unknown> = Required<LibraryBlobsRecord> & BaseSystemFields<Texpand>
export type LibraryTokensResponse<Tinstalled = unknown, Texpand = unknown> = Required<LibraryTokensRecord<Tinstalled>> & BaseSystemFields<Texpand>
export type McpTokensResponse<Texpand = unknown> = Required<McpTokensRecord> & BaseSystemFields<Texpand>
export type MusclePartsResponse<Texpand = unknown> = Required<MusclePartsRecord> & BaseSystemFields<Texpand>
export type OauthAuthorizationsResponse<Texpand = unknown> = Required<OauthAuthorizationsRecord> & BaseSystemFields<Texpand>
export type OauthClientsResponse<Tredirect_uris = unknown, Texpand = unknown> = Required<OauthClientsRecord<Tredirect_uris>> & BaseSystemFields<Texpand>
export type OauthTokensResponse<Texpand = unknown> = Required<OauthTokensRecord> & BaseSystemFields<Texpand>
export type OfficeAssetsResponse<Tframes = unknown, Ttags = unknown, Texpand = unknown> = Required<OfficeAssetsRecord<Tframes, Ttags>> & BaseSystemFields<Texpand>
export type OfficeObjectsResponse<Tinteraction = unknown, Texpand = unknown> = Required<OfficeObjectsRecord<Tinteraction>> & BaseSystemFields<Texpand>
export type OfficeRoomsResponse<Tlayers = unknown, Tspawn = unknown, Texpand = unknown> = Required<OfficeRoomsRecord<Tlayers, Tspawn>> & BaseSystemFields<Texpand>
export type OrgMembersResponse<Texpand = unknown> = Required<OrgMembersRecord> & BaseSystemFields<Texpand>
export type OrganicChannelsResponse<Texpand = unknown> = Required<OrganicChannelsRecord> & BaseSystemFields<Texpand>
export type OrganicItemsResponse<Tsent_ads = unknown, Tversions = unknown, Texpand = unknown> = Required<OrganicItemsRecord<Tsent_ads, Tversions>> & BaseSystemFields<Texpand>
export type OrganicRecipesResponse<Tfactors = unknown, Texpand = unknown> = Required<OrganicRecipesRecord<Tfactors>> & BaseSystemFields<Texpand>
export type PomodoroSessionsResponse<Texpand = unknown> = Required<PomodoroSessionsRecord> & BaseSystemFields<Texpand>
export type ProjectsResponse<Texpand = unknown> = Required<ProjectsRecord> & BaseSystemFields<Texpand>
export type ProviderKeysResponse<Tmetrics = unknown, Texpand = unknown> = Required<ProviderKeysRecord<Tmetrics>> & BaseSystemFields<Texpand>
export type SkillPacksResponse<Texpand = unknown> = Required<SkillPacksRecord> & BaseSystemFields<Texpand>
export type SkillVersionsResponse<Tmanifest = unknown, Tscan = unknown, Texpand = unknown> = Required<SkillVersionsRecord<Tmanifest, Tscan>> & BaseSystemFields<Texpand>
export type TamaDaysResponse<Texpand = unknown> = Required<TamaDaysRecord> & BaseSystemFields<Texpand>
export type TaskNumberCountersResponse<Texpand = unknown> = Required<TaskNumberCountersRecord> & BaseSystemFields<Texpand>
export type TasksResponse<Ttags = unknown, Texpand = unknown> = Required<TasksRecord<Ttags>> & BaseSystemFields<Texpand>
export type UsersResponse<Texpand = unknown> = Required<UsersRecord> & AuthSystemFields<Texpand>
export type WorkersResponse<Tcategories = unknown, Ttoday = unknown, Texpand = unknown> = Required<WorkersRecord<Tcategories, Ttoday>> & BaseSystemFields<Texpand>
export type WorkoutDaysResponse<Titems = unknown, Texpand = unknown> = Required<WorkoutDaysRecord<Titems>> & BaseSystemFields<Texpand>
export type WorkoutSessionExercisesResponse<Texpand = unknown> = Required<WorkoutSessionExercisesRecord> & BaseSystemFields<Texpand>
export type WorkoutSetsResponse<Texpand = unknown> = Required<WorkoutSetsRecord> & BaseSystemFields<Texpand>
export type WorkoutTemplatesResponse<Titems = unknown, Texpand = unknown> = Required<WorkoutTemplatesRecord<Titems>> & BaseSystemFields<Texpand>
export type XpEventsResponse<Texpand = unknown> = Required<XpEventsRecord> & BaseSystemFields<Texpand>

// Types containing all Records and Responses, useful for creating typing helper functions

export type CollectionRecords = {
	_authOrigins: AuthoriginsRecord
	_externalAuths: ExternalauthsRecord
	_mfas: MfasRecord
	_otps: OtpsRecord
	_superusers: SuperusersRecord
	ad_items: AdItemsRecord
	ad_journal: AdJournalRecord
	ad_recipes: AdRecipesRecord
	ad_units: AdUnitsRecord
	agent_decision_outbox: AgentDecisionOutboxRecord
	agent_review_events: AgentReviewEventsRecord
	agent_review_targets: AgentReviewTargetsRecord
	agent_reviews: AgentReviewsRecord
	agent_runs: AgentRunsRecord
	agent_secretaries: AgentSecretariesRecord
	agent_statuses: AgentStatusesRecord
	agent_work_items: AgentWorkItemsRecord
	assets: AssetsRecord
	body_measurements: BodyMeasurementsRecord
	cards: CardsRecord
	daily_stats: DailyStatsRecord
	exercises: ExercisesRecord
	flow_asset_tickets: FlowAssetTicketsRecord
	flow_assets: FlowAssetsRecord
	flow_cards: FlowCardsRecord
	flow_categories: FlowCategoriesRecord
	flow_comments: FlowCommentsRecord
	flow_versions: FlowVersionsRecord
	inbox_items: InboxItemsRecord
	inbox_settings: InboxSettingsRecord
	library_blobs: LibraryBlobsRecord
	library_tokens: LibraryTokensRecord
	mcp_tokens: McpTokensRecord
	muscle_parts: MusclePartsRecord
	oauth_authorizations: OauthAuthorizationsRecord
	oauth_clients: OauthClientsRecord
	oauth_tokens: OauthTokensRecord
	office_assets: OfficeAssetsRecord
	office_objects: OfficeObjectsRecord
	office_rooms: OfficeRoomsRecord
	org_members: OrgMembersRecord
	organic_channels: OrganicChannelsRecord
	organic_items: OrganicItemsRecord
	organic_recipes: OrganicRecipesRecord
	pomodoro_sessions: PomodoroSessionsRecord
	projects: ProjectsRecord
	provider_keys: ProviderKeysRecord
	skill_packs: SkillPacksRecord
	skill_versions: SkillVersionsRecord
	tama_days: TamaDaysRecord
	task_number_counters: TaskNumberCountersRecord
	tasks: TasksRecord
	users: UsersRecord
	workers: WorkersRecord
	workout_days: WorkoutDaysRecord
	workout_session_exercises: WorkoutSessionExercisesRecord
	workout_sets: WorkoutSetsRecord
	workout_templates: WorkoutTemplatesRecord
	xp_events: XpEventsRecord
}

export type CollectionResponses = {
	_authOrigins: AuthoriginsResponse
	_externalAuths: ExternalauthsResponse
	_mfas: MfasResponse
	_otps: OtpsResponse
	_superusers: SuperusersResponse
	ad_items: AdItemsResponse
	ad_journal: AdJournalResponse
	ad_recipes: AdRecipesResponse
	ad_units: AdUnitsResponse
	agent_decision_outbox: AgentDecisionOutboxResponse
	agent_review_events: AgentReviewEventsResponse
	agent_review_targets: AgentReviewTargetsResponse
	agent_reviews: AgentReviewsResponse
	agent_runs: AgentRunsResponse
	agent_secretaries: AgentSecretariesResponse
	agent_statuses: AgentStatusesResponse
	agent_work_items: AgentWorkItemsResponse
	assets: AssetsResponse
	body_measurements: BodyMeasurementsResponse
	cards: CardsResponse
	daily_stats: DailyStatsResponse
	exercises: ExercisesResponse
	flow_asset_tickets: FlowAssetTicketsResponse
	flow_assets: FlowAssetsResponse
	flow_cards: FlowCardsResponse
	flow_categories: FlowCategoriesResponse
	flow_comments: FlowCommentsResponse
	flow_versions: FlowVersionsResponse
	inbox_items: InboxItemsResponse
	inbox_settings: InboxSettingsResponse
	library_blobs: LibraryBlobsResponse
	library_tokens: LibraryTokensResponse
	mcp_tokens: McpTokensResponse
	muscle_parts: MusclePartsResponse
	oauth_authorizations: OauthAuthorizationsResponse
	oauth_clients: OauthClientsResponse
	oauth_tokens: OauthTokensResponse
	office_assets: OfficeAssetsResponse
	office_objects: OfficeObjectsResponse
	office_rooms: OfficeRoomsResponse
	org_members: OrgMembersResponse
	organic_channels: OrganicChannelsResponse
	organic_items: OrganicItemsResponse
	organic_recipes: OrganicRecipesResponse
	pomodoro_sessions: PomodoroSessionsResponse
	projects: ProjectsResponse
	provider_keys: ProviderKeysResponse
	skill_packs: SkillPacksResponse
	skill_versions: SkillVersionsResponse
	tama_days: TamaDaysResponse
	task_number_counters: TaskNumberCountersResponse
	tasks: TasksResponse
	users: UsersResponse
	workers: WorkersResponse
	workout_days: WorkoutDaysResponse
	workout_session_exercises: WorkoutSessionExercisesResponse
	workout_sets: WorkoutSetsResponse
	workout_templates: WorkoutTemplatesResponse
	xp_events: XpEventsResponse
}

// Utility types for create/update operations

type ProcessCreateAndUpdateFields<T> = Omit<{
	// Omit AutoDate fields
	[K in keyof T as Extract<T[K], IsoAutoDateString> extends never ? K : never]: 
		// Convert FileNameString to File
		T[K] extends infer U ? 
			U extends (FileNameString | FileNameString[]) ? 
				U extends any[] ? File[] : File 
			: U
		: never
}, 'id'>

// Create type for Auth collections
export type CreateAuth<T> = {
	id?: RecordIdString
	email: string
	emailVisibility?: boolean
	password: string
	passwordConfirm: string
	verified?: boolean
} & ProcessCreateAndUpdateFields<T>

// Create type for Base collections
export type CreateBase<T> = {
	id?: RecordIdString
} & ProcessCreateAndUpdateFields<T>

// Update type for Auth collections
export type UpdateAuth<T> = Partial<
	Omit<ProcessCreateAndUpdateFields<T>, keyof AuthSystemFields>
> & {
	email?: string
	emailVisibility?: boolean
	oldPassword?: string
	password?: string
	passwordConfirm?: string
	verified?: boolean
}

// Update type for Base collections
export type UpdateBase<T> = Partial<
	Omit<ProcessCreateAndUpdateFields<T>, keyof BaseSystemFields>
>

// Get the correct create type for any collection
export type Create<T extends keyof CollectionResponses> =
	CollectionResponses[T] extends AuthSystemFields
		? CreateAuth<CollectionRecords[T]>
		: CreateBase<CollectionRecords[T]>

// Get the correct update type for any collection
export type Update<T extends keyof CollectionResponses> =
	CollectionResponses[T] extends AuthSystemFields
		? UpdateAuth<CollectionRecords[T]>
		: UpdateBase<CollectionRecords[T]>

// Type for usage with type asserted PocketBase instance
// https://github.com/pocketbase/js-sdk#specify-typescript-definitions

export type TypedPocketBase = {
	collection<T extends keyof CollectionResponses>(
		idOrName: T
	): RecordService<CollectionResponses[T]>
} & PocketBase
